import { createContext } from 'react';
export type FeatureFlagContextType = {
  featureFlags: Record<string, boolean>;
};

export /* @__PURE__*/ const FeatureFlagContext = createContext<FeatureFlagContextType>(
  null as unknown as FeatureFlagContextType
);
FeatureFlagContext.displayName = 'Shared Ui feature flag Context';
